import { FormControl, FormHelperText, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import { useEffect } from "react";

const AvailabilityStep = ({ props }) => {
    useEffect(() => {
        if(props.isEdit){
            const ga = props.formData.general_availability === 'Online support only' ? 1 : props.formData.general_availability === 'Online and onsite support' ? 2 : 3;
            props.setFormData(prev => ({ ...prev, general_availability: ga }));
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
                <Grid item xs={12} container >
                    <Grid item>
                        {props.emptyFormProps.includes('general_availability') && <FormHelperText><b style={{ color: '#d32f2f' }}>This field is required</b></FormHelperText>}
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <p>
                        You have the option of providing remote or on-site support, or a combination of both. Support hours per week will depend on the needs of the host & your own availability. When matched with an institution, we ask for commitment throughout the duration of the project, regardless of the type of support offered.
                    </p>
                    <p>
                        Online support consists of regular videocalls to offer mentoring and advice on specific topics. Onsite support would consist of 10-14 day trips to the host institution to provide direct advice and supervision at the host institution.
                    </p>

                    <FormControl fullWidth size="small">
                        <InputLabel id="availability-select-label">I am available for:</InputLabel>
                        <Select
                            labelId="availability-select-label"
                            value={props.formData.general_availability}
                            onChange={props.handleGeneralAvailabilityChange}
                            input={<OutlinedInput label="Specialties" />}
                        >
                            {props.generalAvailabilityValues
                                .map((field) => (
                                    <MenuItem key={field.id} value={field.id}>
                                        <ListItemText primary={field.value} />
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                {props.isGeneralAvailabilityOtherChecked && (
                    <Grid item xs={12} mt={'15px'}>
                        <TextField
                            fullWidth
                            label="Please specify you availability"
                            name="general_availability_other"
                            value={props.formData.general_availability_other}
                            onChange={props.handleInputChange}
                            size="small"
                        />
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
}

export default AvailabilityStep;